export const DEFAULT_CHANNEL_NAME = 'MESSENGER_DEFAULT_CHANNEL';
